module.exports = __webpack_public_path__ + "static/media/image.ce47147e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/CovidSocial/image.jpg
// module id = 453
// module chunks = 0